<template>
  <section class="SectionWhySolarLanding">
    <Wrap>
      <Headline>
        {{ $t('headline') }}
      </Headline>
      <Wrap class="md">
        <Row v-for="item in reasons" :key="item.icon" class="items">
          <Column :md="2">
            <div class="item">
              <Icon :name="item.icon" />
            </div>
          </Column>
          <Column :md="10">
            <div class="item">
              <span class="label">
                {{ item.title }}
              </span>
              {{ item.content }}
            </div>
          </Column>
        </Row>
      </Wrap>
    </Wrap>
  </section>
</template>

<script>
import { mergeLabels } from 'views/utils'

export default {
  data() {
    return {
      perksValues: [
        { icon: 'arrows-up-down' },
        { icon: 'wallet' },
        { icon: 'tree' },
        { icon: 'like' },
        { icon: 'government' },
      ],
    }
  },
  computed: {
    reasons() {
      return mergeLabels(this.perksValues, this.$ta('reasons'))
    },
  },
}
</script>

<style lang="scss">
.SectionWhySolarLanding {
  background-color: $white;
  overflow: hidden;

  .Row.items {
    padding-top: 2rem;
  }

  .Icon {
    color: $grey;
    font-size: 6rem;
    text-align: center;

  }

  .item {
    display: flex;
    flex-direction: column;
    margin-bottom: 2rem;
    text-align: left;
    @include md {
      margin-bottom: 3rem;
    }

    .label {
      color: $main;
      font-weight: $bold;
      margin: 1rem 0;
      text-transform: uppercase;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "headline": "Why solar?",
    "reasons": []
  },
  "lt": {
    "headline": "Kodėl verta įsigyti?",
    "reasons": [
      {
        "title": "Atsiperka per 5-9 metus",
        "content": "Priklausomai nuo elektros sąnaudų, pasirinkto sprendimo ir finansavimo sąlygų, elektrinė atsipirks per 5-9 metus."
      },
      {
        "title": "70% MAŽESNĖ ELEKTROS SĄSKAITA",
        "content": "Įsigiję saulės elektrinę tapsite tvarios energijos gamintojais ir sumažinsite savo elektros sąskaitą iki 80%."
      },
      {
        "title": "Mažesnė tarša",
        "content": "10 kW saulės elektrinė mažina taršą iki 5 tūkstančių tonų CO2 per metus. Gamindami saulės energiją saugote aplinką ir švarinate orą."
      },
      {
        "title": "Ilgalaikė nauda jums",
        "content": "Saulės elektrinė užtikrina didesnę Jūsų turto vertę ir padeda išvengti kylančių elektros kainų."
      },
      {
        "title": "Galimybė gauti valstybės paramą",
        "content": "Valstybė ir Europos Sąjunga kasmet skiria lėšų atsinaujinančios energetikos plėtrai. Pasinaudoti parama ir pagreitinti saulės elektrinės atsipirkimą galite ir Jūs."
      }
    ]
  }
}
</i18n>
